import styled from 'styled-components';

import { BaseTagStyles } from '../styles/baseTagStyles';

const Tag = styled.div<any>`
  ${BaseTagStyles};
  color: ${({ theme }) => theme.colors.GREY_DARK};
`;

const Verified = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-left: ${({ theme }) => theme.spacing.S4};
`;

function HerdwatchTag() {
  return (
    <Tag textColor="GREY_DARK" bgColor="GREY_LIGHTER">
      <Verified>Verified</Verified>
      <svg
        width="60"
        height="14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M59.998.225L24.016 2.547v8.673l35.982 2.526V.226z"
          fill="#007DB4"
        />
        <path
          d="M33.764 5.026l-1.96 6.194h-1.516l-1.134-3.753-1.134 3.753h-1.516l-1.96-6.194h1.689L27.28 8.83l1.12-3.803h1.505l1.121 3.816 1.048-3.816h1.69zM39.068 8.123c0-1.04-.727-1.747-1.713-1.747-.986 0-1.701.706-1.701 1.747 0 1.041.727 1.745 1.705 1.745.978 0 1.713-.706 1.713-1.747l-.004.002zm1.596-3.103v6.195h-1.596v-.727c-.443.559-1.11.905-2.01.905-1.639 0-2.99-1.421-2.99-3.27 0-1.848 1.355-3.27 2.995-3.27.9 0 1.566.346 2.01.904v-.732l1.59-.005zM44.23 6.56v2.585c0 .668.48.68 1.393.631v1.447c-2.232.248-2.983-.413-2.983-2.08V6.56h-1.068V5.025h1.072v-1.25l1.59-.484v1.734h1.394V6.56H44.23zM46.233 8.123c0-1.846 1.38-3.27 3.255-3.27 1.208 0 2.256.644 2.761 1.598l-1.368.805c-.247-.508-.777-.827-1.406-.827-.949 0-1.651.706-1.651 1.697 0 .992.702 1.685 1.651 1.685.642 0 1.172-.31 1.419-.817l1.38.792a3.164 3.164 0 01-1.175 1.188 3.143 3.143 0 01-1.613.42c-1.874 0-3.255-1.425-3.255-3.27M58.87 7.417v3.803h-1.59V7.615c0-.843-.505-1.276-1.22-1.276-.776 0-1.356.459-1.356 1.536v3.345h-1.59V2.547h1.59V5.72c.37-.559 1.01-.868 1.837-.868 1.307 0 2.33.917 2.33 2.565z"
          fill="#fff"
        />
        <path
          d="M5.756 7.417v3.803h-1.59V7.615c0-.843-.505-1.276-1.22-1.276-.776 0-1.356.459-1.356 1.536v3.345H0V2.547h1.59V5.72c.37-.559 1.011-.868 1.837-.868 1.307 0 2.33.917 2.33 2.565zM11.354 7.541c-.197-.892-.863-1.252-1.528-1.252-.851 0-1.431.46-1.615 1.252h3.143zm-1.38 2.404c.617 0 1.108-.26 1.38-.62l1.283.743c-.58.843-1.506 1.326-2.689 1.326-2.07 0-3.378-1.425-3.378-3.27 0-1.847 1.32-3.271 3.256-3.271 1.824 0 3.118 1.447 3.118 3.27-.001.22-.022.44-.062.657H8.236c.22.817.898 1.165 1.738 1.165zM22.428 8.123c0-1.04-.727-1.747-1.701-1.747-.974 0-1.714.706-1.714 1.747 0 1.041.727 1.747 1.714 1.747.986 0 1.7-.706 1.7-1.747zm1.59-5.576v8.673h-1.59v-.732c-.443.57-1.098.905-1.998.905-1.651 0-3.007-1.425-3.007-3.271 0-1.846 1.356-3.27 3.008-3.27.9 0 1.554.333 1.997.904V2.55l1.59-.004zM17.33 5.024v1.408c0 .05-.013.071-.096.074-1.148.039-1.766.414-1.766 1.434v3.147a.12.12 0 01-.033.083.114.114 0 01-.083.035h-1.635V5.276v-.183a.118.118 0 01.112-.115c.02 0 .039.003.057.012l1.06.64c.029.014.051.016.096-.015a4.257 4.257 0 012.17-.711.116.116 0 01.118.117"
          fill="#B5C428"
        />
      </svg>
    </Tag>
  );
}

export { HerdwatchTag };
